import React, { Component } from 'react';
import Utils from '../utils';
import UI from '../ui';

const { WrappedButton } = UI;
const { Logger, Session, Util } = Utils;

class UserConfiguration extends Component {
	constructor(props) {
		super(props);

		const brand = Session.getBrand();

		this.state = {
			communicationMethod: null,
			fraudNumber: Util.getFraudNumber(brand),
		};

		Logger.logToServer({
			verificationStep: 'step1',
			action: 'View',
		});
	}

	selectCommunicationMethod = e => {
		const { startAccountVerification } = this.props;
		const commMethod = e.currentTarget.getAttribute('communicationmethod');

		this.setState(
			{
				communicationMethod: commMethod,
			},
			() => {
				startAccountVerification(commMethod);
			}
		);

		Logger.saveActionData('Select Communication Method Button Clicked', {
			Method: commMethod,
		});
	};

	render() {
		const { fraudNumber, communicationMethod } = this.state;
		const { phoneNumber, email, startAccountVerificationError } = this.props;

		return (
			<div className="common-account-verification-user-configuration">
				<>
					<p>
						For security purposes, we need to send a verification code to make sure it's
						you. Please choose a verification method.
					</p>
					<p>
						<b>{`Send code to: ${Util.maskEmail(email)} or ${Util.maskPhoneNumber(
							phoneNumber
						)}`}</b>
					</p>
				</>
				{startAccountVerificationError && (
					<div>
						<span className="error-icon" />
						<span className="error-message">{startAccountVerificationError}</span>
					</div>
				)}
				<div className="action-bar">
					<WrappedButton
						label="Email Me"
						buttonType="icon"
						className={communicationMethod === 'email' ? 'email active' : 'email'}
						onClick={this.selectCommunicationMethod}
						communicationmethod="email"
						dataqa="email-verification-button"
					/>
					{Util.removePhoneFormatting(phoneNumber).length <= 10 && (
						<WrappedButton
							label="Text Me"
							buttonType="icon"
							className={communicationMethod === 'sms' ? 'text active' : 'text'}
							onClick={this.selectCommunicationMethod}
							communicationmethod="sms"
							dataqa="sms-verification-button"
						/>
					)}
					<WrappedButton
						label="Call Me"
						buttonType="icon"
						className={communicationMethod === 'voice' ? 'call active' : 'call'}
						onClick={this.selectCommunicationMethod}
						communicationmethod="voice"
						dataqa="voice-verification-button"
					/>
				</div>
				<p className="help-text">
					<i>
						<b>Having trouble receiving your code?</b> You can call our support team at{' '}
						{fraudNumber} between 6 a.m. and 6 p.m. Pacific Time.
					</i>
				</p>
			</div>
		);
	}
}

export default UserConfiguration;
